/* eslint-disable import/first */
import { lazy } from 'react';

// Lazy load meeting components - these are the same components used in admin
const LazyMeeting = lazy(() => import('views/admin/meeting'));
const LazyMeetingTranscript = lazy(() => import('views/admin/meeting/transcript'));

const standaloneRoutes = [
  {
    name: 'Meeting',
    layout: '/meetings',
    path: '/:conversationId',
    component: <LazyMeeting />,
  },
  {
    name: 'Meeting Room',
    layout: '/meetings',
    path: '/:conversationId/:roomType',
    component: <LazyMeeting />,
  },
  {
    name: 'Meeting Transcript',
    layout: '/meetings',
    path: '/:conversationId/transcript',
    component: <LazyMeetingTranscript />,
  },
];

export default standaloneRoutes;





